import { compose } from 'ramda';

import { toNotFound, redirectTo } from '#src/store/location/actions';
import { selectParams } from '#src/store/location/selectors';
import { selectTimeZone } from '#src/store/intl/selectors';
import { getJoinGameAction } from '#src/lib/game-utils/get-join-game-action';
import { checkJoinability, query } from '#src/lib/game-utils/check-joinability';
import { appendParams } from '#src/lib/url-builders/url-utils';

export const path = '/game-landing/:gameId';

export const component = 'Loading';

export const thunk =
  ({ graphqlClient }) =>
  async (dispatch, getState) => {
    const state = getState();
    const { gameId, product, ...otherParams } = selectParams(state);
    const gameType = product === 'waybetter' ? 'falkor' : product;
    const timeZone = selectTimeZone(state);

    if (!gameId || !gameType || !timeZone) dispatch(toNotFound());

    const { data, error } = await graphqlClient.query({
      query,
      fetchPolicy: 'network-only',
      variables: { gameId, gameType, timeZone },
    });
    const game = data?.game || {};

    if (error) {
      dispatch(toNotFound());
      return;
    }

    const { dependsOnMembership, membershipOfferId, potentiallyJoinable } =
      await checkJoinability(game);
    const nextStep =
      !!potentiallyJoinable &&
      getJoinGameAction({
        gameId,
        gameType,
        membershipOfferId,
        redirectToMembership: dependsOnMembership,
        theme: product,
      });

    if (nextStep) {
      compose(dispatch, redirectTo, appendParams(otherParams))(nextStep);
      return;
    }

    dispatch(toNotFound());
  };
